var $ = require('jquery'),
    PhotoSwipe = require('photoswipe'),
    PhotoSwipeUi_Default = require('./photoswipe/photoswipe-ui-default');

/**
 * ImagGallery
 * @class
 */
export class ImageGallery {

  private pswpElement;
  private items;
  private $items;
  private options;
  private $el;
  private block;
  private jsBlock;
  private gallery;

  constructor(private galleryElement:HTMLElement, private galleryClass) {
    this.pswpElement = document.querySelectorAll('.pswp')[0];

    this.block = galleryClass;
    this.jsBlock = 'js-' + this.block;
    this.$el = $(galleryElement);

    this.options = {
      index: 0 // start at first slide
    };
  }

  private _getItems() {
    var items = [];

    this.$items = this.$el.find('.' + this.jsBlock + '__image-wrapper');

    this.$items.each(function() {
      var $this = $(this),
          item = {
            'src': $this.attr('href'),
            'w': $this.data('image-width'),
            'h': $this.data('image-height')
          };

      items.push(item);
    });

    return items;
  }

  private _showGalleryItem(index) {
    this.options.index = index;

    this.gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUi_Default, this.items, this.options);
    this.gallery.init();
  }

  private _initClickListener() {
    var self = this;

    this.$items.on('click', function(e) {
      e.preventDefault();
      self._showGalleryItem($(this).data('image-index'));
    });
  }

  public init() {
    var self = this,
        options;

    this.items = this._getItems();

    this.options = {
        getThumbBoundsFn: function(index) {
        var test = self.$items.eq(index)[0],
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = test.getBoundingClientRect();

        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      },
      index: 0,
      showHideOpacity: true,
      bgOpacity: 0.8,
      history: false,
      shareEl: false
    };

    this._initClickListener();
  }
}
